import React from "react";

export default function MissingSellerPage() {
    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <div style={styles.title}>Catálogo indisponível</div>

                <div style={styles.sub}>
                    Para acessar esta página, use o link enviado por uma Revendedora.
                </div>
            </div>
        </div>
    );
}

const styles = {
    page: {
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        boxSizing: "border-box",
        background: "linear-gradient(180deg, rgba(144,35,72,0.08), #f6f7fb 220px)",
    },

    card: {
        width: "100%",
        maxWidth: 520,
        background: "#fff",
        borderRadius: 18,
        padding: "28px 26px",
        border: "1px solid rgba(17,24,39,0.08)",
        boxShadow: "0 16px 40px rgba(0,0,0,0.08)",
        textAlign: "center",
    },

    title: {
        fontSize: 24,
        fontWeight: 900,
        color: "#111827",
    },

    sub: {
        marginTop: 10,
        color: "#4b5563",
        fontWeight: 600,
        lineHeight: 1.5,
    },

    tipBox: {
        marginTop: 20,
        padding: 14,
        borderRadius: 12,
        background: "rgba(144,35,72,0.08)",
        color: "#902348",
        fontWeight: 700,
        fontSize: 14,
    },
};